import React from 'react';
import { TAppRoutes } from '../../app/features/routes/types/TAppRoute';
import Contacts from './Contacts';

const ContactRoutes = {
	index: {
		tag: 'contacts',
		path: '/contacts',
		auth: true,
		layout: 'investor',
		component: <Contacts />,
	},
} as TAppRoutes;

export default ContactRoutes;
